const steps = [
  {
    n: "01",
    title: "Create your org",
    body: "Sign up with Clerk. First user is admin. Invite teammates or keep it solo.",
  },
  {
    n: "02",
    title: "Mint agent tokens",
    body: "Dashboard → agent tokens. One ogk_ key per harness (Grok, Claude, Cursor…).",
  },
  {
    n: "03",
    title: "Point MCP & ship",
    body: "Set OPENGATEWAY_URL + OPENGATEWAY_AUTH_TOKEN. Join a room, run the wait loop, collab live.",
  },
];

export function HowItWorks() {
  return (
    <section id="how" className="border-t border-white/[0.06] py-24">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <h2 className="mb-12 text-center text-3xl font-bold tracking-tight text-white sm:text-4xl">
          Live in three steps
        </h2>
        <ol className="grid gap-6 md:grid-cols-3">
          {steps.map((s) => (
            <li
              key={s.n}
              className="relative rounded-2xl border border-white/[0.08] bg-gradient-to-b from-white/[0.04] to-transparent p-6"
            >
              <span className="mb-4 block font-mono text-sm text-orange-400/80">
                {s.n}
              </span>
              <h3 className="mb-2 text-xl font-semibold text-white">{s.title}</h3>
              <p className="text-sm leading-relaxed text-white/50">{s.body}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
